import React, { useEffect, useMemo } from 'react';
import { useAppShell } from '../contexts/AppShellContext';
import { useProxyData } from '../contexts/ProxyDataContext';
import { useEscalationContact } from '../contexts/EscalationContactContext';
import { useProxyWorkflowContext } from '../hooks/useProxyWorkflowContext';
import { useProxyEscalation } from '../hooks/useProxyEscalation';
import { buildProxyIntakeTasks, escalationFor } from '../data/proxyWorkflowRegistry';
import { ProxyTaskTable } from '../components/proxy/ProxyTaskTable';

// Everything waiting on the ICT manager: tasks a person escalated, with
// their reason, and tasks where the SOP makes the call the manager's, which
// Ace sends up itself. Approving the task clears it; a person-escalated task
// can also be sent back to the team.
export function ProxyEscalationsPage() {
  const { setTopbar } = useAppShell();
  const { jobs } = useProxyData();
  const ctx = useProxyWorkflowContext();
  const { sendBack } = useProxyEscalation();
  const { contact } = useEscalationContact();
  const who = !contact ? 'the ICT manager'
    : contact.manager_out && contact.backup ? `${contact.backup.name}, covering for ${contact.manager.name}`
    : contact.routed_to.name;

  useEffect(() => {
    setTopbar('Proxy Escalations', `Decisions waiting on ${who}. Some were escalated by the team, others Ace sent up because the procedure says the manager decides.`);
  }, [setTopbar, who]);

  const rows = useMemo(() => {
    const tasks = buildProxyIntakeTasks(ctx);
    return tasks
      .map(task => ({ task, job: jobs.find(j => j.jobId === task.jobId)! }))
      .filter(r => r.job && escalationFor(r.task, r.job, ctx.emails));
  }, [ctx, jobs]);

  return (
    <div className="h-full overflow-auto px-6 py-6">
      <ProxyTaskTable
        rows={rows}
        emptyTitle="Nothing waiting on the manager"
        emptyBody="No one has escalated a task, and nothing open needs a manager's decision."
        onSendBack={sendBack}
      />
    </div>
  );
}
